import React, { FC } from 'react';
import classNames from 'classnames';
import { get, isNull } from 'lodash';
import { useParams } from 'react-router-dom';

import Image from 'vibo-ui/Image';
import Tooltip from 'vibo-ui/Tooltip';
import PublicLabel from 'components/labels/PublicLabel';
import ContentArea from 'components/common/ContentArea';
import StopPropagationWrapper from 'components/common/StopPropagationWrapper';
import Icon, { IconmoonFont } from 'vibo-ui/Icon';

import { LONG_TITLE_SIZE } from './constants';

import { SongIdeasType } from 'types/enums';
import { PlaylistCardProps } from './interfaces';

import useStyles from './style';

const PlaylistCard: FC<PlaylistCardProps> = ({
  onClick,
  playlist,
  className,
  actionButton,
  image = '',
}) => {
  const classes = useStyles();

  const params = useParams<{ type: SongIdeasType }>();

  const playlistImage =
    playlist?.coverPhoto?.cropped?.medium ||
    playlist?.coverPhoto?.url ||
    playlist?.coverPhoto?.cropped?.small ||
    image;

  const syncSettings = get(playlist, 'syncSettings', null) as Nullable<SongIdeasSyncSettings>;

  return (
    <Tooltip overlay={playlist.title.length > LONG_TITLE_SIZE ? playlist.title : null} type="black">
      <ContentArea
        className={classNames('playlistCard', classes.playlistCard, className)}
        onClick={onClick}
        shadowed
      >
        <div className={classNames('cardMiddle', classes.cardMiddle)}>
          {isNull(playlist.songsCount) ? null : (
            <div className="songsCount">
              <Icon icon={IconmoonFont['musicNoteDoubleOutlined-16']} />
              {playlist.songsCount || null}
            </div>
          )}
          {playlist.isPublic && params.type !== SongIdeasType.vibo ? (
            <PublicLabel className="whiteBg" />
          ) : null}
          {actionButton!! ? <StopPropagationWrapper>{actionButton}</StopPropagationWrapper> : null}
          {syncSettings?.spotify?.isSynchronized ? (
            <Tooltip overlay="Synchronized with Spotify" type="black" placement="top">
              <Icon icon={IconmoonFont['spotifyColorful-24']} className="sourceIcon" />
            </Tooltip>
          ) : null}
          <Image src={playlistImage} gradientId={playlist.title}>
            <Icon icon={IconmoonFont['musicNoteDoubleOutlined-24']} disableAutoFontSize />
          </Image>
        </div>
        <div className="title">{playlist.title}</div>
      </ContentArea>
    </Tooltip>
  );
};

export default PlaylistCard;
